import React, { useState } from 'react';
import axios from 'axios';
import { Loader2, ArrowLeft, MailCheck } from 'lucide-react';
import BrandLogo from '../components/branding/BrandLogo';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [devToken, setDevToken] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/forgot-password`, { email });
      setDevToken(res.data?.devToken || '');
      setSent(true);
    } catch {
      setSent(true); // never reveal whether the account exists
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6">
      <div className="w-full max-w-md space-y-8">
        <BrandLogo variant="full" imgClassName="h-16 w-auto mx-auto" />
        {!sent ? (
          <form onSubmit={submit} className="space-y-5" data-testid="forgot-password-form">
            <div className="text-center">
              <h1 className="text-2xl font-bold text-foreground">Forgot your password?</h1>
              <p className="text-sm text-muted-foreground mt-2">Enter your email and we'll send you a reset link.</p>
            </div>
            <input
              type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              placeholder="you@company.com"
              className="h-12 w-full px-4 bg-background border border-border rounded-md text-base outline-none focus:ring-2 focus:ring-primary/30"
              data-testid="forgot-email-input"
            />
            <button type="submit" disabled={loading}
              className="h-12 w-full bg-primary text-primary-foreground font-bold rounded-md disabled:opacity-50 flex items-center justify-center gap-2"
              data-testid="forgot-submit-button">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : 'Send reset link'}
            </button>
            <a href="/login" className="flex items-center justify-center gap-1 text-sm text-muted-foreground hover:text-foreground" data-testid="back-to-login-link">
              <ArrowLeft className="w-4 h-4" /> Back to sign in
            </a>
          </form>
        ) : (
          <div className="text-center space-y-4" data-testid="forgot-success">
            <MailCheck className="w-12 h-12 mx-auto text-green-600" />
            <h1 className="text-2xl font-bold text-foreground">Check your email</h1>
            <p className="text-sm text-muted-foreground">
              If an account with that email exists, a password reset link has been sent. The link expires in 60 minutes.
            </p>
            {devToken && (
              <div className="p-3 bg-amber-50 border border-amber-200 rounded-md text-xs text-amber-800" data-testid="dev-reset-link">
                Email delivery isn't configured in this environment. Continue via:
                <a className="block mt-1 font-mono break-all underline" href={`/reset-password?token=${devToken}`}>
                  /reset-password?token={devToken.slice(0, 12)}…
                </a>
              </div>
            )}
            <a href="/login" className="inline-flex items-center gap-1 text-sm text-primary hover:underline">
              <ArrowLeft className="w-4 h-4" /> Back to sign in
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
